import { render, staticRenderFns } from "./ReporteSolicitudes.vue?vue&type=template&id=1c4da90d"
import script from "./ReporteSolicitudes.vue?vue&type=script&lang=js"
export * from "./ReporteSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports